import React from "react";
import { motion } from "framer-motion";
import { EALogo } from "@/components/brand/EALogo";

export const Contact = () => (
  <section
    id="contact"
    className="relative py-28 md:py-40 bg-ink-950 overflow-hidden"
    data-testid="contact-section"
  >
    <div className="absolute inset-0 pointer-events-none">
      <div
        className="aurora-blob animate-aurora-slow"
        style={{ background: "#00F0FF", width: 720, height: 720, top: "-20%", left: "-10%", opacity: 0.35 }}
      />
      <div
        className="aurora-blob animate-aurora"
        style={{ background: "#39FF14", width: 560, height: 560, bottom: "-20%", right: "-5%", opacity: 0.3 }}
      />
    </div>

    <div className="relative mx-auto max-w-[1600px] px-6 md:px-10">
      <div className="flex items-baseline justify-between border-b border-white/10 pb-6 mb-16">
        <div className="font-mono text-[11px] tracking-[0.35em] uppercase text-spectrum-green">
          ◢ Get in touch
        </div>
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/40">
          One inbox
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-[7.5vw] font-black leading-[0.88] tracking-tighter text-white mb-10"
            data-testid="contact-title"
          >
            Write to <span className="spectrum-text">Erik.</span>
          </motion.h2>
          <p className="text-white/60 text-base md:text-lg font-light max-w-2xl mb-10 leading-relaxed">
            Investors, ERP integrators, IoT vendors, journalists and prospective
            hires — every enquiry lands directly in the founder&apos;s inbox. No forms,
            no funnel, no gatekeeper.
          </p>
          <a
            href="mailto:erik@svenskainvest.com"
            className="inline-flex items-center gap-4 bg-spectrum-green px-8 py-5 font-mono text-xs md:text-sm uppercase tracking-[0.3em] text-ink-950 hover:bg-white transition-colors"
            data-testid="contact-mailto"
          >
            erik@svenskainvest.com →
          </a>
        </div>

        <div className="lg:col-span-4 flex items-center justify-center">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-spectrum-cyan via-spectrum-violet to-spectrum-green blur-3xl opacity-70 animate-pulseGlow" />
            <div className="relative w-56 h-56 md:w-72 md:h-72 rounded-full bg-ink-950 border border-white/10 flex items-center justify-center">
              <span className="text-spectrum-green">
                <EALogo size={140} strokeWidth={5} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
